import useRequest from '@/websdk/utils/request';
export default (function () {
  const { data, isRequestSuccessed } = useRequest({
    url: '/api/devicedatanew/statistics',
    name: 'device_data_new',
    method: 'GET',
  });
  return [data, isRequestSuccessed];
});
